/**
 * 片刻延迟处理
 */
export class DelayMoment {
  /**
   * 延迟时间
   */
  duration = 500;

  /**
   * 当前时间
   */
  startTime = new Date();

  /**
   * 延迟处理类
   * @param duration 延迟持续的时间
   */
  constructor(duration?: number) {
    if (duration) {
      this.duration = duration;
    }
  }

  /**
   * 等待延时完成
   * @returns
   */
  done() {
    return new Promise((resolve) => {
      const delay = this.duration - (new Date().getTime() - this.startTime.getTime());
      setTimeout(() => {
        resolve(true);
      }, Math.max(delay, 0));
    });
  }
}
